import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative mx-auto w-full max-w-md">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-xl border border-background-300/70 bg-white px-5 py-4 text-left transition-colors hover:border-primary-300 cursor-pointer shadow-sm"
      >
        <span className="flex items-center gap-3 text-sm font-medium text-foreground-700">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
            <i className="ri-price-tag-3-line text-base"></i>
          </span>
          {t('selector.placeholder')}
        </span>
        <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
          <i className={`ri-arrow-down-s-line text-lg transition-transform ${open ? 'rotate-180' : ''}`}></i>
        </span>
      </button>

      {open && (
        <div className="absolute z-30 mt-2 max-h-80 w-full overflow-y-auto rounded-xl border border-background-200 bg-white p-1.5 shadow-lg">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between rounded-lg px-4 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-50 cursor-pointer"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {t(`categories.${cat.id}`, cat.name)}
              </span>
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}